import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Close } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { deleteImportListProduct, deleteProduct } from "../../../api/product";
import { authSelector } from "../../../redux/slices/authSlice";
import { deleteTransaction } from "../../../api/transaction";
import { Icon } from "@iconify/react";
import { deleteCarrier, deleteShipping } from "../../../api/shipping";
import { deleteStore, updateStoreUser } from "../../../api/store";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  textAlign: "center",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: "30px 40px",
  outline: "none",
  borderRadius: "10px",
};

export default function ConfirmationModal({
  title,
  confirm,
  icon,
  elementId,
  styleBG,
  store,
  userId,
}) {
  const [open, setOpen] = React.useState(false);
  const { loggedUser } = useSelector(authSelector);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const dispatch = useDispatch();

  const handleDelete = () => {
    if (loggedUser?.user?.role === "admin") {
      if (elementId?.transaction_for && !elementId?.variant_options) {
        dispatch(deleteTransaction(elementId?._id));
      }
      if (elementId?.variant_options) {
        dispatch(deleteProduct(elementId?._id));
      }
      if (elementId?.shipping_id) {
        dispatch(
          deleteCarrier({
            shippingId: elementId?.shipping_id,
            carrierId: elementId?._id,
          })
        );
      }
      if (elementId?.shipping_formulas) {
        dispatch(deleteShipping(elementId._id));
      }
      if (
        elementId?.store &&
        !elementId?.variant_options &&
        !elementId?.transaction_for
      ) {
        dispatch(deleteStore(elementId?.store));
      }
    } else {
      // dispatch(deleteImportListProduct(elementId));
      dispatch(
        updateStoreUser({
          userId: userId,
        })
      );
    }

    handleClose();
  };

  return (
    <div>
      {icon === "delete-user" ? (
        <h6 style={{ color: "red", cursor: "pointer" }} onClick={handleOpen}>
          Delete
        </h6>
      ) : icon === "delete" ? (
        <Icon
          icon="carbon:trash-can"
          width="20"
          height="20"
          style={{
            cursor: "pointer",
            background: `${styleBG && styleBG}`,
            color: `${styleBG ? "white" : "inherit"}`,
          }}
          onClick={handleOpen}
        />
      ) : (
        // <DeleteOutline
        //   onClick={handleOpen}
        //   sx={{ marginRight: "20px", cursor: "pointer", color: "gray" }}
        // />
        <Close
          onClick={handleOpen}
          sx={{ cursor: "pointer", color: "gray", fontSize: "14px" }}
        />
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-description"
            variant="h2"
            component="h2"
            sx={{ fontSize: "24px", fontWeight: "600" }}
          >
            {title}
          </Typography>
          <Box
            sx={{
              marginTop: "30px",
            }}
          >
            {store && confirm === "Remove" ? (
              <Button
                variant="red"
                sx={{ width: "auto", marginRight: "20px" }}
                onClick={() =>
                  (window.location.href = `https://admin.shopify.com/store/${store}/settings/apps?tab=installed`)
                }
              >
                {confirm}
              </Button>
            ) : (
              <Button
                variant="red"
                sx={{ width: "auto", marginRight: "20px" }}
                onClick={handleDelete}
              >
                {confirm}
              </Button>
            )}
            <Button
              variant="deepblue"
              sx={{ width: "auto" }}
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
